import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
export default {
  title: 'Spaces Map',
  attributeName: 'spacesMapForm',
  helpText: 'Here we can see all the spaces reachable from the entry point',
  cssClass:'color-canvas-map',
  fields: [
    {
      attributeName: 'spacesMap',
      label:'Entry Point Canvas Link',
      type: FormInputTypes.SPACES_MAP,
      
    },   
  ],
};
